// extracted by mini-css-extract-plugin
module.exports = {"centreThumbnail":"styles-module_centreThumbnail__3OkEib5Fii1meXLeezqLfy"};